import { Button } from 'antd-v5';
import type { ButtonProps } from 'antd-v5';
import styles from './index.module.scss';

const BlackButton: React.FC<ButtonProps> = ({ className, ...props }) => {
    return <Button className={`${styles.BlackButton} ${className ?? ''}`} {...props} />;
};

export default BlackButton;
